import styled from 'styled-components';
import { rem } from 'polished';
import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledCalendarHeader = styled.div`
  background-color: ${props => props.theme.colors.dark};
  display: flex;
  height: auto;
  align-items: center;
  justify-content: space-between;
  padding: ${rem('10px')};
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
   justify-content: center;
   background-color: ${props => props.theme.colors.light};
   min-height: ${rem('61px')};
  `};
`;

const StyledBtnLeft = styled(ButtonArrowLeft)`
  fill: ${props => props.theme.colors.light};
  position: initial;
  height: ${rem('20px')};
  ${mediaqueries.greaterThan('mobile')`
   height: ${rem('40px')};
   fill: ${props => props.theme.colors.dark};
  `};
  ${props =>
    props.event &&
    `
    display: none;
  `};
`;

const StyledBtnRight = styled(ButtonArrowRight)`
  fill: ${props => props.theme.colors.light};
  position: initial;
  height: ${rem('20px')};
  ${mediaqueries.greaterThan('mobile')`
    fill: ${props => props.theme.colors.dark};
    height: ${rem('40px')};
  `};
  ${props =>
    props.event &&
    `
    display: none;
  `};
`;
const DateWrapper = styled.div`
  text-align: center;
  width: 100%;
  ${mediaqueries.greaterThan('tablet')`
    width: ${rem('202px')};
  `};
`;

const StyleMonth = styled.span`
  color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.book};
  text-align: right;
  text-transform: uppercase;
  font-size: ${rem('15px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('20px')};
   color: ${props => props.theme.colors.dark};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('14px')};
  `};
`;

const StyleYear = styled.span`
  font-family: ${props => props.theme.fonts.medium};
  color: ${props => props.theme.colors.light};
  text-transform: uppercase;
  font-size: ${rem('15px')};
  ${mediaqueries.greaterThan('mobile')`
   font-size: ${rem('20px')};
   color: ${props => props.theme.colors.dark};
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('14px')};
  `};
`;

export {
  StyledCalendarHeader,
  StyledBtnLeft,
  StyledBtnRight,
  StyleMonth,
  StyleYear,
  DateWrapper
};
